module.exports = __webpack_public_path__ + "img/pekao.787e2845.svg";